import { Region as RegionSchema } from '@workday/wcp-sdk';
import { Audience } from './auth';

export enum Region {
  DE = 'scylla:de',
  FEDERAL = 'scylla:us-fed',
  IL4 = 'scylla:il4',
  PERFORMANCE = 'scylla:us-perf',
  US = 'scylla:us',
  EUSC = 'scylla:eu-sov',
}

export const REGIONAL_OCTO_DEVSITE_ID = 1;

export interface RegionWithAudience extends RegionSchema {
  platform: Audience;
}
